import { Brand } from '../types/Brand';

const API_URL = process.env.REACT_APP_API_URL || '/api';

export const BrandService = {
  // Get all brands
  getAllBrands: async (): Promise<Brand[]> => {
    try {
      const response = await fetch(`${API_URL}/brands`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          ...(localStorage.getItem('token') && { 'Authorization': `Bearer ${localStorage.getItem('token')}` })
        },
        mode: 'cors'
      });
      
      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }
      
      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Failed to fetch brands:', error);
      throw error;
    }
  },
  
  // Get a single brand by ID
  getBrandById: async (id: number): Promise<Brand> => {
    try {
      const response = await fetch(`${API_URL}/brands/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          ...(localStorage.getItem('token') && { 'Authorization': `Bearer ${localStorage.getItem('token')}` })
        },
        mode: 'cors'
      });
      
      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }
      
      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error(`Failed to fetch brand with ID ${id}:`, error);
      throw error;
    }
  },
  
  // Create a new brand
  createBrand: async (brand: Brand): Promise<Brand> => {
    try {
      const response = await fetch(`${API_URL}/brands`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          ...(localStorage.getItem('token') && { 'Authorization': `Bearer ${localStorage.getItem('token')}` })
        },
        mode: 'cors',
        body: JSON.stringify(brand)
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
      }
      
      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Failed to create brand:', error);
      throw error;
    }
  },
  
  // Update an existing brand
  updateBrand: async (id: number, brand: Brand): Promise<Brand> => {
    try {
      const response = await fetch(`${API_URL}/brands/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          ...(localStorage.getItem('token') && { 'Authorization': `Bearer ${localStorage.getItem('token')}` })
        },
        mode: 'cors',
        body: JSON.stringify(brand)
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
      }
      
      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error(`Failed to update brand with ID ${id}:`, error);
      throw error;
    }
  },
  
  // Delete a brand
  deleteBrand: async (id: number): Promise<void> => {
    try {
      const response = await fetch(`${API_URL}/brands/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          ...(localStorage.getItem('token') && { 'Authorization': `Bearer ${localStorage.getItem('token')}` })
        },
        mode: 'cors'
      });
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
      }
    } catch (error) {
      console.error(`Failed to delete brand with ID ${id}:`, error);
      throw error;
    }
  }
};

export default BrandService; 